"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertNotesSchema = exports.NOT_INTEGER = exports.SHARE_NUMBER_MIN = exports.SHARE_NUMBER_REQUIRED = exports.AMOUNT_REQUIRED = exports.SHARECLASS_REQUIRED = exports.DATE_MAX = exports.DATE_MIN = exports.DATE_VALID = exports.DATE_REQUIRED = void 0;
const moment_1 = __importDefault(require("moment"));
const yup = __importStar(require("yup"));
const OptionGrant_1 = require("./OptionGrant");
exports.DATE_REQUIRED = "Please enter a date";
exports.DATE_VALID = "Please enter a valid date";
exports.DATE_MIN = "Date cannot be before Issue date";
exports.DATE_MAX = "Date cannot be in future";
exports.SHARECLASS_REQUIRED = "Share class is required";
exports.AMOUNT_REQUIRED = "Amount is required";
exports.SHARE_NUMBER_REQUIRED = "Number of shares required";
exports.SHARE_NUMBER_MIN = "Cannot be less than one share";
exports.NOT_INTEGER = "Number must not contain decimal places";
exports.ConvertNotesSchema = yup.object().shape({
    transactionType: yup.string().required("Exit type not selected"),
    shareClassId: yup
        .string()
        .when(["transactionType", "$type"], ([transactionType, type], schema) => transactionType === "converted" && type !== "convertible"
        ? schema.required(exports.SHARECLASS_REQUIRED)
        : schema.notRequired()),
    investmentAmount: yup.lazy((investmentAmount) => investmentAmount === ""
        ? yup.string().required(exports.AMOUNT_REQUIRED)
        : yup
            .number()
            .when("$payOutAmount", ([payOutAmount], schema) => schema.test("investmentAmount", "Cannot be less than amount invested", (amount) => amount >= payOutAmount))),
    quantity: yup.lazy((quantity) => quantity === ""
        ? yup
            .string()
            .when("transactionType", ([transactionType], schema) => transactionType === "converted" ? schema.required(exports.SHARE_NUMBER_REQUIRED) : schema.notRequired())
        : yup.number().when("transactionType", ([transactionType], schema) => transactionType === "converted"
            ? schema
                .required(exports.SHARE_NUMBER_REQUIRED)
                .min(1, exports.SHARE_NUMBER_MIN)
                .test("isInteger", exports.NOT_INTEGER, (value) => value % 1 === 0)
            : schema.notRequired())),
    dateOfTransaction: yup
        .string()
        .required(exports.DATE_REQUIRED)
        .when("$issueDate", ([issueDate], schema) => schema
        .test("validDate", exports.DATE_VALID, (dateOfTransaction) => (0, moment_1.default)(dateOfTransaction).isValid())
        .test("Date-in-past", exports.DATE_MIN, (dateOfTransaction) => new Date(dateOfTransaction).valueOf() >= new Date(issueDate).valueOf())
        // eslint-disable-next-line no-shadow
        .when("transactionType", ([transactionType], schema) => transactionType === "converted"
        ? schema.test("Date-in-future", exports.DATE_MAX, (dateOfTransaction) => new Date(dateOfTransaction).valueOf() <= new Date().valueOf())
        : schema.notRequired())),
    authorisingOfficer: OptionGrant_1.AuthorisingOfficerSchema.when("transactionType", ([transactionType], schema) => transactionType === "converted" ? schema.required("Please select authorising officer") : schema.notRequired()),
});
//# sourceMappingURL=ConvertNote.js.map